// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"743":"73cebb1c","993":"73cebb1c"}[chunkId] + ".css";
};